<script setup>
import { computed } from 'vue'
import Select from './Select.vue'

const props = defineProps({
    modelValue: {
        type: String,
        default: null,
    },
    placeholder: {
        type: String,
        default: 'Select time',
    },
    format24: {
        type: Boolean,
        default: false,
    },
})

// label, value pair
const options = computed(() => {
    // from 00:00 to 23:00, 5 minutes interval, no seconds
    const times = []

    for (let h = 0; h < 24; h++) {
        for (let m = 0; m < 60; m += 5) {
            const hour = h.toString().padStart(2, '0')
            const minute = m.toString().padStart(2, '0')
            const time = `${hour}:${minute}`

            times.push({
                label: props.format24 ? time : format12(time),
                value: props.format24 ? time : format12(time),
            })
        }
    }

    return times
})

const format12 = (time) => {
    const [hour, minute] = time.split(':')
    const h = parseInt(hour, 10)
    const m = parseInt(minute, 10)
    const ampm = h >= 12 ? 'PM' : 'AM'
    const hour12 = h % 12 || 12
    const minute12 = m.toString().padStart(2, '0')

    return `${hour12}:${minute12} ${ampm}`
}

</script>



<template>
    <Select iconBefore="plus" :options="options" v-model="props.modelValue" :placeholder="placeholder" @change="$emit('update:modelValue', props.modelValue)" selectionContainer="py-[10px]"></Select>
</template>
